module.exports = __webpack_public_path__ + "img/bg.0ccf88b9.png";